// Page de connexion.
import { $ } from './core/dom.ts';
import { mascot } from './features/mascot.ts';

// Tequila (avec son accessoire de saison) salue sur la carte de connexion
$('#login-tq').innerHTML = mascot(84, 'wave');

const form = $<HTMLFormElement>('#login');
form.addEventListener('submit', async (ev) => {
  ev.preventDefault();
  const data = new FormData(form);
  const err = $('#err');
  err.textContent = '';
  const r = await fetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: data.get('email'), password: data.get('password') }),
  });
  if (r.ok) location.href = new URLSearchParams(location.search).get('suite') === 'audit' ? '/audit/' : '/app';
  else err.textContent = ((await r.json().catch(() => ({}))) as { error?: string }).error || 'Connexion impossible.';
});

// Connexion sans mot de passe : un lien valable 7 jours est envoyé à l'adresse indiquée, si elle a un accès
const linkForm = $<HTMLFormElement>('#link-form');
$('#show-link').addEventListener('click', (ev) => {
  linkForm.hidden = false;
  (ev.currentTarget as HTMLElement).hidden = true;
  const typed = (form.elements.namedItem('email') as HTMLInputElement).value;
  const input = linkForm.elements.namedItem('email') as HTMLInputElement;
  input.value = typed;
  input.focus();
});
linkForm.addEventListener('submit', async (ev) => {
  ev.preventDefault();
  const msg = $('#link-msg');
  const r = await fetch('/api/login/link', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: new FormData(linkForm).get('email') }),
  });
  msg.textContent = r.ok
    ? 'Si cette adresse a un accès à VSPulse, un lien de connexion vient de lui être envoyé. Pensez à regarder dans les indésirables.'
    : ((await r.json().catch(() => ({}))) as { error?: string }).error || 'Envoi impossible.';
});
